import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { usePersonalStore } from '../../../stores/personalInfo'
import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const MtInformationOnline = ({ navigation, route }: any) => {

    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
    } = params

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postmtonline } = useFormsStore()

    const handlesubmit = async (signatureDataURL: string) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey:
                intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey:
                essUserOnBoardingFormKey,
            completeOnline: true,
            filingStatus: values?.filingstatus,
            extraWithholding: values?.additionaltax ? values?.additionaltax : null,
            specifiedWithholding: values?.specifiedwithholding ? values?.specifiedwithholding : null,
            taxYear: new Date().getFullYear(),
            reasonForExemptTax: values?.reasonforexempttax ? values?.reasonforexempttax : null,
            sign: signatureDataURL
        }
        const response: any = await postmtonline(data)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MT Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('MtInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}

export default MtInformationOnline
